import { mountVueComponent } from '@/lib/mount-vue-component';

export default function() {
  import('@/modules/clear/component/RegistrationForm.vue').then(RegistrationForm => {
    mountVueComponent('registration-form', RegistrationForm, true);
  });
}